<template>
  <div :class="useClassName">
    <a
      v-if="getAttribute('previewFile') && getAttribute('showRearrange')"
      @click="uploadOnPreview(propsData.code)"
    >
      <img
        :id="getId"
        :src="
          getAttribute('previewFile') + '?v=' + getUploadedFileUniqueVersion()
        "
      />
    </a>
    <a
      v-if="getAttribute('previewFile') && !getAttribute('showRearrange')"
      :data-fancybox="'gallery' + propsData.refId"
      :href="getAttribute('previewFileLink')"
    >
      <img
        :id="getId"
        :src="
          getAttribute('previewFile') + '?v=' + getUploadedFileUniqueVersion()
        "
      />
    </a>
  </div>
</template>
<script>
import { useUploadsStore } from "@/stores/modules/uploads";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useUploadsStore, [
      "getUploadForProductPart",
      "getUploadItemId"
    ]),
    getId: function () {
      return this.getUploadItemId(this.propsData.code) + "Img";
    }
  },
  methods: {
    ...mapActions(useUploadsStore, ["uploadOnPreview"]),
    getUploadedFileUniqueVersion: function () {
      return Math.floor(Math.random() * 99999);
    },
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    }
  },
  props: ["propsData", "useClassName"]
};
</script>
